import AmountSelector from "components/AmountSelector/AmountSelector.vue";
import debounce from "foundation/js/debounce";

import { computed, ref, watch } from "vue";
import { useStore } from "vuex";

export default {
    name: "BasketCard",
    components: { AmountSelector },

    props: {
        data: {
            type: Object,
            required: true,
        },
        variantData: {
            type: Object,
            required: true,
        },
        link: { type: String, required: false },
        displayMessage: {
            type: Function,
            required: false,
        },
        soldOut: {
            type: Boolean,
            required: false,
            default: false,
        },
        alreadyRemoved: {
            type: Boolean,
            required: false,
            default: false,
        },
        handleDeleteButton: {
            type: Function,
            required: false,
        },
        miniBasket: {
            type: Boolean,
            required: false,
            default: false,
        },
        errorMaxAmountMessage: {
            type: String,
            required: false,
        },
        errorMinAmountMessage: {
            type: String,
            required: false,
        },
        removeItem: {
            type: Function,
        },
        cancelRemoveItem: {
            type: Function,
        },
        readOnlyAmount: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(props, { emit }) {
        const store = useStore();
        const amount = ref(props.variantData.variant.quantity);

        const setAmount = function (inputAmount, sku) {
            amount.value = inputAmount;

            debounce(function () {
                store.dispatch("basket/adjustQuantity", {
                    sku: props.variantData.variant.sku,
                    newquantity: amount.value,
                });
            }, 750)();
        };

        const handleDeleteButton = function () {
            let productNumber = props.data.productNumber;
            if (props.soldOut) {
                emit("removeItem", { sku: productNumber, immediate: true });
                return;
            }
            displayAlreadyRemoved(true);
            emit("removeItem", { sku: productNumber });
            setTimeout(()=>{
                // setTimeout makes sure the DOM is ready before we select the button
                const focusTarget = document.querySelector(`#product-undo-delete-${props.variantData.variant.sku}`)
                if(focusTarget) focusTarget.focus()
            },25)
        };

        const displayMaxAmountMessage = ref();
        const displayMinAmountMessage = ref();

        const displayMessage = function (show) {
            if (show === "max-error") {
                displayMinAmountMessage.value = "";
                displayMaxAmountMessage.value = show
                    ? "kb-product-detail__error-message--show"
                    : "";
            } else if (show === "min-error") {
                displayMaxAmountMessage.value = "";
                displayMinAmountMessage.value = show
                    ? "kb-product-detail__error-message--show"
                    : "";
            } else {
                displayMinAmountMessage.value = "";
                displayMaxAmountMessage.value = "";
            }
        };

        // show validation error message from rest api
        const hasError = computed(() => props.data.errors.hasErrors);
        const firstError = computed(() => props.data.errors.values[0]);
        const validationError = { show: false, message: "" };
        
        watch(
            [hasError, firstError],
            () => {
                validationError.show = hasError.value && !props.soldOut;
                validationError.message = validationError.show
                    ? props.data.errors.values[0].message
                    : "";
            },
            { immediate: true },
        );

        const displaySoldOutMessage = ref(props.soldOut);
        const displaySoldOut = function (payload) {
            displaySoldOutMessage.value = payload;
        };

        const displayAlreadyRemovedFromBasket = ref(props.alreadyRemoved);
        const displayAlreadyRemoved = function (payload, sku) {
            if (!payload) emit("cancelRemoveItem", sku);
            displayAlreadyRemovedFromBasket.value = payload;
        };

        return {
            displayMaxAmountMessage,
            displayMinAmountMessage,
            displayMessage,
            validationError,
            displaySoldOutMessage,
            displaySoldOut,
            displayAlreadyRemovedFromBasket,
            displayAlreadyRemoved,
            handleDeleteButton,
            setAmount,
            getLabel: (labelKey) =>
                store.getters["labels/getLabel"]({
                    labelCollection: "cart",
                    labelKey,
                }),
        };
    },
};
